finderApp.factory('throttle', ['$timeout', '$q', function($timeout, $q) {
    return function(callback, interval) {
        var timeout = null,
            deferred = null;

        return function() {
            $timeout.cancel(timeout);

            if (!deferred) {
                deferred = $q.defer();
            }

            var args = arguments;

            timeout = $timeout(function () {

                $q.when(callback.apply(this, args))
                    .then(deferred.resolve, deferred.reject);

                deferred = null;

            }, interval);

            return $q.when(deferred.promise);
        };
    };
}]);